const confirmViewReducer = (state = {}, action) => {
	switch(action.type){
	case 'CONFIRMVIEWVALUE':
		return action.payload;
	default:
		return state;
	}
}

export default confirmViewReducer;